import React from 'react';
import Component from '@vfuk/core-icon-button';
const IconButton = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default IconButton;
